<template>
  <v-card
    justify-center
    wrap
    class="pa-2 my-2"
    flat
    v-if="facebook || instagram || youtube || website"
  >
    <v-subheader v-if="facebook || instagram || youtube || website"
      >Social Media</v-subheader
    >
    <v-card-actions>
      <a target="_blank" :href="facebook" v-if="facebook">
        <v-icon class="mr-1" color="#3b5998">fab fa-facebook-square</v-icon>
      </a>
      <a
        target="_blank"
        :href="'https://www.instagram.com/' + instagram"
        v-if="instagram"
      >
        <v-icon class="mr-1" color="#ca3ab9">fab fa-instagram</v-icon>
      </a>
      <a :href="youtube" v-if="youtube">
        <v-icon class="mr-1" color="red">fab fa-youtube</v-icon>
      </a>
      <a target="_blank" :href="website" v-if="website">
        <v-icon class="mr-1" color="secondary">mdi-link</v-icon>
      </a>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["facebook", "instagram", "youtube", "website"],
};
</script>
